import { Button } from "../../../../components/ui/button";
import { Link } from "react-router-dom";
import { Rocket, MessageCircle, Calendar, Users, Trophy } from "lucide-react";

const CTA: React.FC = () => {
	const highlights = [
		{
			icon: Calendar,
			label: "2024年7月20-21日",
		},
		{
			icon: Users,
			label: "定員30名",
		},
		{
			icon: Trophy,
			label: "賞金総額50万円",
		},
	];

	return (
		<section className="relative py-24 overflow-hidden">
			{/* 背景グラデーション */}
			<div className="absolute inset-0 bg-gradient-to-br from-purple-600 to-indigo-800" />

			{/* 装飾的な背景パターン */}
			<div className="absolute inset-0 bg-grid-white/[0.2] bg-grid-16" />

			{/* メインコンテンツ */}
			<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center">
					<h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
						アイデアを形に、仲間と共に。
					</h2>
					<p className="text-xl text-purple-100 mb-8 max-w-2xl mx-auto">
						プログラミングスキルの有無に関わらず、地域をより良くしたいという
						想いを持つ方のご参加をお待ちしています。
					</p>

					{/* ハイライト情報 */}
					<div className="flex flex-wrap justify-center gap-8 mb-12">
						{highlights.map((item) => (
							<div
								key={item.label}
								className="flex items-center gap-2 text-white"
							>
								<item.icon className="w-5 h-5" />
								<span className="text-lg">{item.label}</span>
							</div>
						))}
					</div>

					{/* CTAボタン */}
					<div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
						<Button
							asChild
							size="lg"
							className="bg-white text-purple-600 hover:bg-purple-50"
						>
							<Link
								to="/hackathon/entry"
								className="flex items-center gap-2 px-8"
							>
								<Rocket className="w-5 h-5" />
								エントリーする
							</Link>
						</Button>
						<Button
							asChild
							size="lg"
							variant="outline"
							className="text-white border-white hover:bg-purple-500"
						>
							<Link to="/contact" className="flex items-center gap-2 px-8">
								<MessageCircle className="w-5 h-5" />
								お問い合わせ
							</Link>
						</Button>
					</div>

					{/* 締め切り情報 */}
					<p className="text-purple-100">
						応募締切：2024年6月30日
						<span className="inline-block mx-2">|</span>
						<Link
							to="/hackathon/guidelines"
							className="text-white hover:text-purple-200 underline"
						>
							参加ガイドライン
						</Link>
					</p>
				</div>
			</div>
		</section>
	);
};

export default CTA;
